<template>
    <div class="typing-indicator" :class="variant_class">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
export default {
    name: 'TypingIndicator',

    props: {
        variant: {
            type: String,
            default: 'chat',
            validator: (v) => ['chat', 'sms'].includes(v)
        }
    },

    computed: {
        variant_class() {
            return `typing-indicator--${this.variant}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.typing-indicator {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.75rem 1rem;
    border-radius: 1rem;

    span {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        animation: typing-bounce 1.4s infinite ease-in-out;

        &:nth-child(1) { animation-delay: 0s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.4s; }
    }

    // chat variant (embedded chat interface)
    &--chat {
        background: white;
        border-bottom-left-radius: 0.25rem;

        span {
            background: #aaa;
        }
    }

    // SMS variant (mock text conversation)
    &--sms {
        background: var(--incoming-color, #E5E5EA);
        border-radius: 18px;
        padding: 0.8rem 1rem;

        span {
            width: 6px;
            height: 6px;
            background: #999;
        }
    }
}

@keyframes typing-bounce {
    0%, 60%, 100% {
        transform: translateY(0);
        opacity: 0.5;
    }
    30% {
        transform: translateY(-0.35rem);
        opacity: 1;
    }
}
</style>
